import React from 'react'

import Grid from '@material-ui/core/Grid';

import ManagementHistoryTable from '../components/ManagementHistoryTable'
import IssueOrRevokeShares from '../components/IssueOrRevokeShares'


function Management() {



  return (
    <div>
      <br/>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <IssueOrRevokeShares/>
        </Grid>
        <Grid item xs={12}>
        <ManagementHistoryTable />
        </Grid>
      </Grid>
    </div>
  )
}

export default Management
